"use client";

import { useTranslations } from "next-intl";
export function TermsAndConditions() {
  const tTerms = useTranslations("modules.policiesAndTerms.termsAndConditions");
  return <div className="container mx-auto px-4 py-12 sm:py-8 max-w-4xl" data-sentry-component="TermsAndConditions" data-sentry-source-file="TermsAndConditions.tsx">
      <h1 className="text-3xl font-bold mb-1">{tTerms("title")}</h1>
      <p className="text-sm text-gray-400 mb-8">{tTerms("lastUpdated")}</p>

      <div className="mb-8">
        <p className="mb-4">{tTerms("intro")}</p>
      </div>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tTerms("section1Title")}
        </h2>
        <p className="mb-4">{tTerms("section1Content")}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tTerms("section2Title")}
        </h2>
        <p className="mb-4">{tTerms("section2Content1")}</p>
        <p className="mb-4">{tTerms("section2Content2")}</p>
        <p className="mb-4">{tTerms("section2Content3")}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tTerms("section3Title")}
        </h2>
        <p className="mb-4">{tTerms("section3Content1")}</p>
        <p className="mb-4">{tTerms("section3Content2")}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tTerms("section4Title")}
        </h2>
        <p className="mb-4">{tTerms("section4Content1")}</p>
        <p className="mb-4">{tTerms("section4Content2")}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tTerms("section5Title")}
        </h2>
        <p className="mb-4">{tTerms("section5Content")}</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4">
          {tTerms("section6Title")}
        </h2>
        <p className="mb-4">{tTerms("section6Content")}</p>
      </section>
    </div>;
}